

















import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetCrfsMuban, SaveGauge } from "@/request/projects";
import TransferCmp from "../mobans/transferCmp.vue";
@Component({
  components: {
    TransferCmp,
  },
})
export default class Gauge extends Vue {
  private id: any = "";
  private patientId: any = "";
  private data: any = {};
  private resultList: any = [];
  private getMuban() {
    const params = {
      params: {
        template_id: this.id,
      },
    };
    GetCrfsMuban(this, params).then((res) => {
      this.data = res;
      this.handleMountedZiduans();
    });
  }
  /**
   * @description 初步加载时，给所有字段套壳
   */
  private handleMountedZiduans() {
    const source: any[] = this.data["模板"];
    source.map((item: any, index: any) => {
      if (item.big_title) {
        this.resultList.push({
          label: "标题",
          content: {
            title: item.big_title,
            type: "标签",
          },
          count: 0,
        });
      } else if (item.top_title) {
        this.resultList.push({
          label: "问题组",
          content: {
            title: item.top_title,
            type: "问题组",
          },
          count: 0,
        });
      } else if (
        item.type === "多选" ||
        item.type === "计分多选" ||
        item.type === "单层多选" ||
        item.type === "多层多选"
      ) {
        this.resultList.push({ label: "多选题", content: item, count: 0 });
      } else if (item.type === "文件") {
        this.resultList.push({ label: "文件上传", content: item, count: 0 });
      } else if (
        item.type === "固定单位数字" ||
        item.type === "可变单位数字" ||
        item.type === "数字"
      ) {
        this.resultList.push({ label: "数值题", content: item, count: 0 });
      } else if (item.type === "计分条") {
        this.resultList.push({ label: "标尺", content: item, count: 0 });
      } else if (item.type === "字符串" || item.type === "文本域") {
        this.resultList.push({ label: "文本题", content: item, count: 0 });
      } else if (item.type === "单个时间") {
        this.resultList.push({ label: "时间", content: item, count: 0 });
      } else if (item.type === "主诉" || item.type === "主要症状名称") {
        this.resultList.push({ label: "搜索单选", content: item, count: 0 });
      } else {
        this.resultList.push({ label: item.type, content: item, count: 0 });
      }
    });
    console.log("结果");
    console.log(this.resultList);
    this.reCalResultListIndex();
  }
  /**
   * @description 重新计算结果序号
   */
  private reCalResultListIndex() {
    let count: number = 0;
    const arr: any[] = [];
    this.resultList.map((item: any, index: any) => {
      let t = 0;
      if (item.label === "标题" || item.label === "问题组") {
        t = count++;
      } else {
        t = count;
      }
      arr.push(t);
    });
    const ne = this.resultList.map((item: any, index: any) => {
      const obj = _.cloneDeep(item);
      obj.count = arr[index];
      return obj;
    });
    this.resultList = ne;
  }
  /**
   * @description 数据改变
   */
  private dataChange(val) {
    console.log("数据改变");
    console.log(val);
    this.data["模板"][val.index] = val.content;
    console.log(this.data);
  }
  /**
   * @description 提交
   */
  private submit() {
    console.log(this.data);
    console.log(this.patientId);
    const params = {
      patient_id: this.patientId,
      project_id: this.data.project_id,
      group_id: this.data.group_id,
      template_id: this.data.template_id,
      data: this.data,
    };
    SaveGauge(this, params).then((res) => {
      console.log("保存");
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.template_id) {
      this.$message.error("量表不存在");
      this.$router.back();
      return;
    }
    this.id = this.$route.query.template_id;
    this.patientId = this.$route.query.patient_id;
    this.getMuban();
  }
}
